import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  profilId$: string;
  tcNo$: string;
  yerineGirisMi$: boolean;
  profil$: Observable<any>;
  profilAdSoyad$: Observable<any>;
  resimId$: Observable<any>;
  basvuruAsamasindaMi$: Observable<boolean>;
  onBasvuruAsamasindaMi$: Observable<boolean>;

  private profilMethod = new ReplaySubject<any>();
  private profilAdSoyadMethod = new ReplaySubject<any>();
  private resimMethod = new ReplaySubject<any>();
  private basvuruAsamasindaMiMethod = new ReplaySubject<boolean>();
  private onBasvuruAsamasindaMiMethod = new ReplaySubject<boolean>();

  constructor() {
    this.profil$ = this.profilMethod.asObservable();
    this.profilAdSoyad$ = this.profilAdSoyadMethod.asObservable();
    this.resimId$ = this.resimMethod.asObservable();
    this.basvuruAsamasindaMi$ = this.basvuruAsamasindaMiMethod.asObservable();
    this.onBasvuruAsamasindaMi$ = this.onBasvuruAsamasindaMiMethod.asObservable();

    // Varsayılan değerler
    this.basvuruAsamasindaMiMethod.next(false);
    this.onBasvuruAsamasindaMiMethod.next(false);
  }

  setProfilBilgi(aday, yerineGirisMi) {
    this.tcNo$ = aday.tcNo;
    this.yerineGirisMi$ = yerineGirisMi;
    this.profilId$ = aday.profilId;
    this.profilMethod.next(aday);
  }

  setAdSoyadBilgi(aday) {
    this.profilAdSoyadMethod.next(aday);
  }

  setResimId(resimId) {
    this.resimMethod.next(resimId);
  }

  setBasvuruAsamasindaMi(basvuruAsamasindaMi) {
    this.basvuruAsamasindaMiMethod.next(basvuruAsamasindaMi);
  }

  basvuruAsamasindaMi(): any {
    return this.basvuruAsamasindaMi$;
  }
  setOnBasvuruAsamasindaMi(onBasvuruAsamasindaMi) {
    this.onBasvuruAsamasindaMiMethod.next(onBasvuruAsamasindaMi);
  }
  onBasvuruAsamasindaMi(): any {
    return this.onBasvuruAsamasindaMi$;
  }

  setReturnUrl(url: string) {
    sessionStorage.setItem('returnUrl', url);
  }

  getReturnUrl(): string {
    const url = sessionStorage.getItem('returnUrl');
    sessionStorage.removeItem('returnUrl');
    return url;
  }
}